import { __rest } from "tslib";
import React from 'react';
import TooltipTrigger from 'react-popper-tooltip';
import './tooltip.less';
// @ts-ignore
const Tooltip = (_a) => {
    var { children, tooltip } = _a, props = __rest(_a, ["children", "tooltip"]);
    return (
    // @ts-ignore
    React.createElement(TooltipTrigger, Object.assign({}, props, { tooltip: (x) => (React.createElement("div", Object.assign({}, x.getTooltipProps({
            className: 'tooltip-container',
            ref: x.tooltipRef,
        })), tooltip())) }), ({ getTriggerProps, triggerRef }) => (React.createElement("span", Object.assign({}, getTriggerProps({
        className: 'trigger',
        ref: triggerRef,
    })), children))));
};
export default Tooltip;
//# sourceMappingURL=tooltip.js.map